var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedeemptionFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 0C54.1499 0 41.0993 3.9588 29.999 11.3758C18.8987 18.7928 10.2471 29.3348 5.13817 41.6688C0.029233 54.0026 -1.30747 67.5748 1.29702 80.6685C3.90151 93.7621 10.3303 105.789 19.7703 115.23C29.2104 124.67 41.2377 131.098 54.3314 133.703C67.4251 136.307 80.9973 134.971 93.3309 129.862C105.665 124.753 116.207 116.101 123.624 105.001C131.041 93.9005 135 80.8501 135 67.4999C135 58.6358 133.254 49.8583 129.862 41.6688C126.47 33.4794 121.498 26.0382 115.23 19.7703C108.962 13.5023 101.521 8.5303 93.3309 5.13809C85.1418 1.74595 76.3641 0 67.5 0ZM99.2925 89.7074L89.775 99.2249L67.5 77.0174L45.2925 99.2924L35.7075 89.7074L57.9825 67.4999L35.7075 45.2924L45.2925 35.7075L67.5 57.9824L89.7075 35.775L99.225 45.2924L77.0175 67.4999L99.2925 89.7074Z",
    fill: "#FF1818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemptionFail);
export default __webpack_public_path__ + "static/media/redeemption-fail.35bba53578a05b57e8171894e2f51e11.svg";
export { ForwardRef as ReactComponent };